import React, { FC, SyntheticEvent } from 'react';
import { FieldState, Input } from 'informed';
import cn from 'classnames';
import './styles.scss';

export interface IText {
  className?: string;
  disabled?: boolean;
  errorClassName?: string;
  formatter?: Array<string | RegExp>;
  initialValue?: string;
  label?: string | JSX.Element;
  labelClassName?: string;
  min?: string;
  max?: string;
  name: string;
  placeholder?: string;
  type?: string;
  validateOnBlur?: boolean;
  mask?: (value: string) => string;
  onChange?: ((fieldState: FieldState, event: SyntheticEvent<Element, Event>) => void) | undefined;
  onBlur?: ((fieldState: FieldState, event: SyntheticEvent<Element, Event>) => void) | undefined;
  validate?: (value: unknown, values: Record<string, unknown>) => unknown;
}

const Text: FC<IText> = ({
  name,
  className,
  labelClassName,
  errorClassName,
  label,
  validateOnBlur = true,
  ...rest
}) => {
  return (
    <>
      {label && (
        <label htmlFor={name} className={cn(labelClassName, 'hbh-text-label')}>
          {label}
        </label>
      )}
      <Input
        className={cn('hbh-text-field', className)}
        name={name}
        validateOn={validateOnBlur ? 'blur' : undefined}
        {...rest}
      />
    </>
  );
};

export default Text;
